import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Head extends Component {
	render() {
		return ReactDOM.createPortal(this.props.children, document.querySelector('head'));
	}
}

export default Head;



// WEBPACK FOOTER //
// ./hocs/Head/Head.jsx